import script from "./AdultJaw.vue?vue&type=script&setup=true&lang=js"
export * from "./AdultJaw.vue?vue&type=script&setup=true&lang=js"

import "./AdultJaw.vue?vue&type=style&index=0&id=5d038bcc&scoped=true&lang=css"

import exportComponent from "/var/www/dental/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d038bcc"]])

export default __exports__